import { render } from "./IntegrationPartners.vue?vue&type=template&id=cea9ba8e"
import script from "./IntegrationPartners.vue?vue&type=script&lang=js"
export * from "./IntegrationPartners.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__